var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { assertEx } from '@xyo-network/sdk-xyo-js';
import Gtag from './Gtag';
import Gtm from './Gtm';
class BaseEvent {
    constructor(name, adwordConversionId) {
        this.name = name;
        this.adwordConversionId = adwordConversionId;
    }
    send(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendGtag(data);
        });
    }
    sendGtag(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.gtag().sendAnalytics(this.name, data);
            if (this.adwordConversionId) {
                yield this.gtag().sendAdwords(this.adwordConversionId, data);
            }
        });
    }
    sendGtm(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.gtm().send(this.name, data);
        });
    }
    gtag() {
        return assertEx(Gtag.instance, 'Missing/uninitialized gtag');
    }
    gtm() {
        return assertEx(Gtm.instance, 'Missing/uninitialized gtm');
    }
}
export default BaseEvent;
//# sourceMappingURL=BaseEvent.js.map